import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";

import Header from "./components/Header";
import Page from "./components/Page";

import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Filtro from "./pages/Filtro";
import RelatorioFiltro from "./pages/RelatorioFiltro";
import RelatorioSinistroAssociado from "./pages/Relatorios/RelatorioSinistroAssociado";
import SancorCadastro from "./pages/Sancor/Cadastro";
import Atividades from "./pages/Atividades";
import Importacao from "./pages/Importacao";
import Pasta from "./pages/Pasta";

import AcordoCreate from "./pages/Acordo/Create";

import Devolucoes from "./pages/Crawlers/Devolucoes";
import Acionamentos from "./pages/Crawlers/Acionamentos";
import Causador from "./pages/Crawlers/Causador";
import Buscainfo from "./pages/Crawlers/Buscainfo";

import Pessoas from "./pages/Pessoas";
import ContaHDI from "./pages/ContaHDI";

import RelatorioSMSHot from "./pages/Relatorios/RelatorioSMSHot/index";
import RelatorioSMS from "./pages/Relatorios/RelatorioSMS/RelatorioSMS";
import { RelatorioRateio } from "./pages/Relatorios/Rateio";
import RD from "./pages/Relatorios/RelatorioRD/index";

import Notfound from "./pages/Notfound";

import isAuthenticated from "./services/auth";
import AcordoPastaList from "./pages/Acordo/List/Pasta";
import TiposAcordo from "./pages/Configuracoes/Acordo/TiposAcordo";
import PagarParcelasFile from "./pages/Acordo/PagarParcelas/index";
import CadastroSMS from "./pages/Sms/Cadastro/index";
import AlterarOperador from "./pages/Acordo/alterar_operador";
import ListagemModelo from "./pages/Sms/ListagemModelo/index";
import Envio from "./pages/Sms/Envio/index";

import UserList from "./pages/Usuario/Listagem/index";
import { CadastroForm } from "./pages/Usuario/Listagem/form";
import ResetarSenha from "./pages/Usuario/components/form_senha";
import DadosPlecto from "./pages/Configuracoes/DadosPlecto/index";
import Parcelas from "./pages/Parcelas";
import NotaFiscal from "./pages/NotaFiscal/index";
import NfePipelineView from "./components/NFePipeline";

import ReportParcela from "./pages/Relatorios/Parcela/index";
import ReportPastas from "./pages/Relatorios/RelatorioPastas";
import ReportAcordo from "./pages/Relatorios/Acordo/index";
import ReportFiltro from "./pages/Relatorios/Filtro/index";

import ContaAzul from "./pages/ContaAzul";
import { ContratoRelatorios } from "./pages/Contratos/Relatorios";
import { UploadTXT } from "./pages/Contratos/UploadTXT";
import { UploadContaCorrente } from "./pages/Contratos/UploadContaCorrente";
import { AtualizacaoParcelas } from "./pages/Contratos/AtualizacaoParcelas";
import { RelatorioPrestacaoContas } from "./pages/Relatorios/PrestacaoContas";
import { AtualizarParcelasLotePage } from "./pages/Acordos/AtualizarParcelasLote";
import FeedbackButton from "./components/FeedbackButton";
import Tarefas from "./pages/Tarefas";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <div>{(window.location.href = "/login/")}</div>
      )
    }
  />
);

const Routes = () => {
  return (
    <BrowserRouter>
      <Header />
      <FeedbackButton />
      <div className="page_grid">
        <Switch>
          {/* Rotas públicas (Autenticação) */}
          <Route
            path="/"
            component={props => (
              <Page component={Auth} title="Login" {...props} />
            )}
            exact
          />
          <Route
            path="/login"
            component={props => (
              <Page component={Auth} title="Login" {...props} />
            )}
            exact
          />

          {/** Rotas Dashboard */}
          <PrivateRoute
            path="/dashboard"
            component={props => (
              <Page component={Dashboard} title="Dashboard" {...props} />
            )}
            exact
          />
          <PrivateRoute
            path="/tarefas"
            component={props => (
              <Page component={Tarefas} title="Minhas solicitações" {...props} />
            )}
            exact
          />
          <PrivateRoute
            path="/atividades"
            component={props => (
              <Page
                component={Atividades}
                title="Lista de atividades"
                {...props}
              />
            )}
            exact
          />

          {/** Configurações */}
          <PrivateRoute
            path="/config/acordo/tipos"
            component={props => (
              <Page
                component={TiposAcordo}
                title="Tipos de acordo"
                {...props}
              />
            )}
            exact
          />
          <PrivateRoute path="/contaazul/" component={ContaAzul} />

          {/** Rotas Pasta */}
          <PrivateRoute
            path="/pasta/:id"
            component={props => (
              <Page component={Pasta} title="Detalhes da pasta" {...props} />
            )}
            exact
          />

          {/** Rotas Crawlers */}
          <PrivateRoute
            path="/crawlers/causador"
            component={props => (
              <Page component={Causador} title="Causador" {...props} />
            )}
            exact
          />
          <PrivateRoute
            path="/crawlers/buscainfos"
            component={props => (
              <Page component={Buscainfo} title="Busca infos HDI" {...props} />
            )}
            exact
          />
          <PrivateRoute
            path="/crawlers/devolucoes"
            component={props => (
              <Page component={Devolucoes} title="Devoluções HDI" {...props} />
            )}
            exact
          />
          <PrivateRoute
            path="/crawlers/acionamentos"
            component={props => (
              <Page
                component={Acionamentos}
                title="Acionamentos HDI"
                {...props}
              />
            )}
            exact
          />

          {/** Rotas Filtro */}
          <PrivateRoute
            path="/filtro/relatorio"
            component={props => (
              <Page
                component={RelatorioFiltro}
                title="Relatório de filtros"
                {...props}
              />
            )}
            exact
          />
          <PrivateRoute
            path="/filtro"
            component={props => (
              <Page component={Filtro} title="Filtro" {...props} />
            )}
            exact
          />

          {/** Rotas Sancor */}
          <PrivateRoute
            path="/sancor/cadastro"
            component={props => (
              <Page
                component={SancorCadastro}
                title="Cadastro Sancor"
                {...props}
              />
            )}
            exact
          />

          {/** Rotas de importação */}
          <PrivateRoute
            path="/importacao"
            component={props => (
              <Page
                component={Importacao}
                title="Importação Pipedrive"
                {...props}
              />
            )}
            exact
          />

          {/** Rotas Acordos */}
          <PrivateRoute
            path="/acordo/create/:id"
            component={props => (
              <Page
                component={AcordoCreate}
                title="Cadastrar acordo"
                {...props}
              />
            )}
            exact
          />
          <PrivateRoute
            path="/pasta/:id/acordos"
            component={props => (
              <Page
                component={AcordoPastaList}
                title="Acordos da pasta"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/pagar_parcelas/"
            component={PagarParcelasFile}
            exact
          />

          <PrivateRoute
            path="/parcelas"
            component={props => (
              <Page
                component={Parcelas}
                title="Listagem de parcelas"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/pessoas/"
            component={props => (
              <Page component={Pessoas} title="Pessoas" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/conta-hdi/"
            component={props => (
              <Page component={ContaHDI} title="Contas da HDI" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/smsHot/"
            component={props => (
              <Page
                component={RelatorioSMSHot}
                title="Relatório SMS Hot"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/sms/"
            component={props => (
              <Page component={RelatorioSMS} title="Relatório SMS" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorio-sinistro-associado/"
            component={props => (
              <Page
                component={RelatorioSinistroAssociado}
                title="Relatório SMS"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/filtro/planilha/"
            component={props => (
              <Page component={ReportFiltro} title="Relatório do Filtro" />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/pastas"
            component={props => (
              <Page component={ReportPastas} title="Relatório de Pastas" />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/parcela/"
            component={props => (
              <Page component={ReportParcela} title="Exportar Parcelas" />
            )}
            exact
          />
          <PrivateRoute
            path="/relatorios/acordo/"
            component={props => (
              <Page component={ReportAcordo} title="Exportar Acordos" />
            )}
            exact
          />
          <PrivateRoute
            path="/config/plecto/integracao"
            component={props => (
              <Page
                component={DadosPlecto}
                title="Dados do plecto"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/nota_fiscal/upload/"
            component={NotaFiscal}
            title="Importar Nota Fiscal"
            exact
          />
          <PrivateRoute
            path="/nfe-pipeline"
            component={props => (
              <Page component={NfePipelineView} title="Emissão NFe" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/sms/cadastro/"
            component={props => (
              <Page
                component={CadastroSMS}
                title="Cadastro de sms"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/sms/listagem_modelo/"
            component={props => (
              <Page
                component={ListagemModelo}
                title="Modelos de SMS"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/sms/envio/"
            component={props => (
              <Page component={Envio} title="Envio de SMS" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/user_list"
            component={props => (
              <Page component={UserList} title="Usuários" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/user_update"
            component={props => (
              <Page
                component={CadastroForm}
                title="Atualizar usuário"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/rd/"
            component={props => (
              <Page component={RD} title="Relatório" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/change_owner/"
            component={props => (
              <Page
                component={AlterarOperador}
                title="Alterar Proprietário"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/user_update/password"
            component={props => (
              <Page component={ResetarSenha} title="Alterar senha" {...props} />
            )}
            exact
          />

          <PrivateRoute
            path="/contratos/relatorio"
            component={props => (
              <Page
                component={ContratoRelatorios}
                title="Relatório contrato"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/contratos/upload-txt"
            component={props => (
              <Page
                component={UploadTXT}
                title="Processamento de TXT's"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/contratos/upload-conta-corrente"
            component={props => (
              <Page
                component={UploadContaCorrente}
                title="Upload Conta Corrente"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/contratos/atualizacao-parcelas"
            component={props => (
              <Page
                component={AtualizacaoParcelas}
                title="Atualizar parcelas em lote"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/rateio"
            component={props => (
              <Page
                component={RelatorioRateio}
                title="Relatório de Rateio"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/relatorios/prestacao-contas"
            component={props => (
              <Page
                component={RelatorioPrestacaoContas}
                title="Relatório de Prestação de Contas"
                {...props}
              />
            )}
            exact
          />

          <PrivateRoute
            path="/acordos/atualizar-parcelas"
            component={props => (
              <Page
                component={AtualizarParcelasLotePage}
                title="Atualizar parcelas em lote"
                {...props}
              />
            )}
            exact
          />

          {/** 404 */}
          <Route
            component={props => (
              <Page component={Notfound} title="404" {...props} />
            )}
          />
          <Route component={Notfound} />
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js